import { lazy } from 'react'
import BasicLayout from '../components/layout/BasicLayout'
import routerConstants from '../constants/routerConstants'

const routeMenu: any[] = [
  { path: routerConstants.menu.list, name: 'menuList', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/menus/MenuList')), },
  { path: routerConstants.menu.add, name: 'menuAdd', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/menus/MenuAdd')), },
  { path: routerConstants.menu.edit, name: 'menuEdit', exact: false, layout: BasicLayout, component: lazy(() => import('../components/admin/menus/MenuUpdate')), },
]
export { routeMenu }